import { render, staticRenderFns } from "./notfoundPage.vue?vue&type=template&id=01102b40&scoped=true&"
import script from "./notfoundPage.vue?vue&type=script&lang=js&"
export * from "./notfoundPage.vue?vue&type=script&lang=js&"
import style0 from "./notfoundPage.vue?vue&type=style&index=0&id=01102b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01102b40",
  null
  
)

export default component.exports